const getHighlights = (state: AnyFixMe) => state.stage.highlights;

export { getHighlights };
